import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import appscreen from '../../assets/images/appscreen.png'
import Application from '../../assets/images/applicationvideothumb.png'
import Playbtn from '../../assets/images/play_white.svg'
import Emoji from '../../utils/emoji'

// Images from public folder
const Videobtn = "/assets/images/seeVideo.png";
const SearchIcon = "/assets/images/search-icon.png";
const ChooseIcon = "/assets/images/choose-icon.png";
const RewardIcon = "/assets/images/reward-icon.png";

function About() {

    const [counts, setCounts] = useState({
        niches: 0,
        subcategories: 0,
        serviceproviders: 0,
        rewards: 0,
    });

    useEffect(() => {
        const updateCounter = () => {
            const targetCounts = {
                niches: 10,
                subcategories: 50,
                serviceproviders: 150,
                rewards: 2000,
            };

            const duration = 1200; 
            const stepSize = 10;
            const steps = duration / stepSize;

            Object.keys(targetCounts).forEach((key) => {
                const targetCount = targetCounts[key];
                const currentCount = counts[key];
                const step = Math.ceil((targetCount - currentCount) / steps);

                if (step !== 0) {
                    const interval = setInterval(() => {
                        setCounts((prevCounts) => ({
                            ...prevCounts,
                            [key]: prevCounts[key] + step,
                        }));
                    }, stepSize);

                    setTimeout(() => {
                        clearInterval(interval);
                        setCounts((prevCounts) => ({
                            ...prevCounts,
                            [key]: targetCount,
                        }));
                    }, duration * 1.12);
                }
            });
        };

        updateCounter();
    }, []);


    const [ytshow, setytShow] = useState(false);

    return (
        <>
            <section id="about" className="about_section row_am">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                        <span className="title_badge mb-1">Despre LUMO</span>
                        <h2>
                            Mai mult decât o programare -
                            <Emoji symbol="🔎" label="calendar" className="emoji" />
                            {" "}descoperi, <br />
                            <Emoji symbol="📅" label="calendar" className="emoji" />
                            {" "}rezervi și{" "}
                            <span>
                            <Emoji symbol="🎁" label="calendar" className="emoji" />{" "}câștigi
                            </span>{" "}
                            cu fiecare utilizare.
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <ul className="app_statstic" id="counter" data-aos="fade-in" data-aos-duration={1500} >
                                <li data-aos="fade-up" data-aos-duration={1500}>
                                    <div className="text">
                                        <p>
                                            <span className="counter-value">{counts.niches}</span>
                                            <span>+</span>
                                        </p>
                                        <p>Nișe</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration={1500}>
                                    <div className="text">
                                        <p>
                                            <span className="counter-value">{counts.subcategories}</span>
                                            <span>+</span>
                                        </p>
                                        <p>Categorii<br/>servicii</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration={1500}>
                                    <div className="text">
                                        <p>
                                            <span className="counter-value">{counts.serviceproviders}</span>
                                            <span>+</span>
                                        </p>
                                        <p>Parteneri</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration={1500}>
                                    <div className="text">
                                        <p>
                                            <span>€</span>
                                            <span className="counter-value">{counts.rewards}</span>
                                            <span>+</span>
                                        </p>
                                        <p>Valoare<br/>premii</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="abtImg text-center" data-aos="fade-up" data-aos-duration={1500} >
                                <img src={appscreen} alt="image" />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <p data-aos="fade-up" data-aos-duration={1500}>
                            Cu <span>LUMO</span> găsești rapid profesioniști de încredere pentru orice serviciu – de la frizerie și cosmetică, până la reparații sau activități de wellness. Rezervi în doar câteva secunde și primești puncte de loialitate la fiecare utilizare, pe care le poți transforma în vouchere atractive.
                            </p>
                            <p className="video-block-subtitle">Vezi cât de simplu este să rezervi cu LUMO</p>
                            <div className="video_block" data-aos="fade-up" data-aos-duration={1500} >
                                <img className="thumbnil" src={Application} alt="image" />
                                <div className="playBtn" onClick={() => setytShow(true)}>
                                    <Link to="#" className="popup-youtube play-button play_icon"
                                        data-url="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                                        data-toggle="modal" data-target="#myModal" title="XJj2PbenIsU" >
                                        <img src={Playbtn} alt="img" />
                                    </Link>
                                    <img className="spin_text" src={Videobtn} alt="image" />
                                </div>
                            </div>

                            {/*<div className="btn_block" data-aos="fade-up" data-aos-duration={1500}>
                                <Link to="/contact" className="btn puprple_btn ml-0">
                                    DESCARCĂ LUMO
                                </Link>
                                <div className="btn_bottom" />
                            </div>*/}
                        </div>
                    </div>
                </div>
            </section>

            {ytshow &&
                <div className="modal fade youtube-video show" id="myModal"
                    tabIndex={-1} style={{ display: "block", paddingRight: 17 }}
                    aria-modal="true" role="dialog" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" onClick={() => setytShow(false)}>
                            <button id="close-video"
                                type="button" className="button btn btn-default text-right" data-dismiss="modal" onClick={() => setytShow(false)}>
                                <i className="icofont-close-line-circled" />
                            </button>
                            <div className="modal-body">
                                <div id="video-container" className="video-container">
                                    <iframe id="youtubevideo"
                                        width={640} height={360}
                                        allowFullScreen=""
                                        src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                                    />
                                </div>
                            </div>
                            <div className="modal-footer"></div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default About